(function () {
  function setupSection(selector, speeds) {
    const section = document.querySelector(selector);
    if (!section) return null;

    const items = [];
    Object.keys(speeds).forEach((n) => {
      const el = section.querySelector(`.block-image:nth-of-type(${n})`);
      if (el) items.push({ el, speed: speeds[n] });
    });

    if (!items.length) return null;

    return { section, items };
  }

  // Za sekcije gde elementi imaju unikatne ID-jeve (npr. recipe dekoracije)
  function setupSectionByIds(selector, idSpeeds) {
    const section = document.querySelector(selector);
    if (!section) return null;

    const items = [];
    Object.keys(idSpeeds).forEach((id) => {
      const el = section.querySelector(`#${id}`);
      if (el) items.push({ el, speed: idSpeeds[id] });
    });

    if (!items.length) return null;

    return { section, items };
  }

  // Za sekcije gde elementi imaju stabilne CSS klase (npr. footer dekoracije)
  function setupSectionByClasses(selector, classSpeeds) {
    const section = document.querySelector(selector);
    if (!section) return null;

    const items = [];
    Object.keys(classSpeeds).forEach((cls) => {
      const el = section.querySelector(`.${cls}`);
      if (el) items.push({ el, speed: classSpeeds[cls] });
    });

    if (!items.length) return null;

    return { section, items };
  }

  function setupSectionByNth(selector, speeds) {
  const section = document.querySelector(selector);
  if (!section) return null;

  const items = [];

  Object.entries(speeds).forEach(([index, speed]) => {
    const el = section.querySelector(
      `.recipe-decor-image:nth-of-type(${index})`
    );

    if (el) items.push({ el, speed });
  });

  return items.length ? { section, items } : null;
}

  function initParallax() {
    if (window.innerWidth < 768) return;

    const sections = [
      setupSection('#shopify-section-template--20741406326828__rich_text_TXEFbz', {
        4: 0.15,
        5: 0.10,
        6: 0.30,
        7: 0.30,
        8: 0.10,
        9: 0.10
      }),
      setupSection('#shopify-section-template--20741406326828__rich_text_Xm3fwV', {
        1: 0.05,
        2: 0.25
      }),
      setupSectionByClasses('#shopify-section-sections--20741406916652__footer', {
        'footer-deco--1': 0.35,
        'footer-deco--2': 0.15,
        'footer-deco--3': 0.10,
        'footer-deco--4': 0.10,
        'footer-deco--5': 0.35,
        'footer-deco--6': 0.35,
        'footer-deco--7': 0.35
      }),
      setupSectionByIds('#recipe-details-template--20741406785580__accordion_section_F3Xh6m', {
        'recipe-decor-image_decor_image_a78azA': 0.15,
        'recipe-decor-image_decor_image_tDQXwm': 0.15,
        'recipe-decor-image_decor_image_7jXeGn': 0.35,
        'recipe-decor-image_decor_image_gtMWYC': 0.25,
        'recipe-decor-image_decor_image_iLHNpV': 0.15
      }),
      setupSectionByNth(
  '#recipe-details-template--21055545671724__rich_text_image_parallax_AzhArL',
  {
    2: 0.10, // popcorn_15
    3: 0.22, // popcorn_14
    4: 0.35, // popcorn2
    5: 0.15, // popcorn_15
    6: 0.28, // Group_431
    7: 0.18, // popcorn2
    8: 0.30  // Group_436
  }
),
    ].filter(Boolean);

    if (!sections.length) return;

    let ticking = false;

    function updateParallax() {
      const winH = window.innerHeight;

      sections.forEach(({ section, items }) => {
        const rect = section.getBoundingClientRect();
        const progress = (winH - rect.top) - (rect.height / 2 + winH / 2);

        items.forEach(({ el, speed }) => {
          el.style.transform = `translateY(${progress * speed}px)`;
        });
      });

      ticking = false;
    }

    function onScroll() {
      if (!ticking) {
        requestAnimationFrame(updateParallax);
        ticking = true;
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    updateParallax();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initParallax);
  } else {
    initParallax();
  }
})();